import { Dictionary } from "types";
import { useCartItemContext } from "./CartItem.context";

const CartItemRemove = ({ dictionary }: { dictionary: Dictionary }) => {
  const { item, removeItem } = useCartItemContext();

  if (!item) return null;

  return (
    <button
      type="button"
      className="absolute right-1 top-1 bg-transparent p-2 text-sm text-grey-300 underline hover:text-black"
      onClick={() => removeItem(item)}
    >
      {dictionary?.remove ?? "Remove"}
    </button>
  );
};

CartItemRemove.displayName = "CartItemRemove";

export default CartItemRemove;
